import { reviews } from "@/mocks/home";

export default function Reviews() {
  return (
    <section id="reviews" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-accent-700">
            <i className="ri-chat-smile-2-line"></i>
            用户怎么说
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            来自日常使用的真实反馈
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            不同的人用同一个入口，关注的点却不太一样。有人看重通勤时的缓存，有人更在意大屏下的画质，
            下面整理了一些常见的使用感受。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reviews.map((review) => (
            <figure
              key={review.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex items-center gap-1 text-accent-500" aria-label="五星评价">
                {[0, 1, 2, 3, 4].map((i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">
                {review.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 dark:text-foreground-950 font-heading text-base font-bold">
                  {review.initials}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-950">
                    {review.name}
                  </span>
                  <span className="block text-xs text-foreground-500">{review.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}